/* src/app/global/components/global-help/global-help-icon/global-help-icon.component.scss */
:host {
  background-color: rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: center;
  width: 60px;
}
:host .cw-global-help-icon {
  font-size: 2rem;
  line-height: 30px;
}
/*# sourceMappingURL=global-help-icon.component.css.map */
